export default "__VITE_ASSET__BEERkPvJ__"